import get from 'lodash.get';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';

import {getUserData} from 'Services/API';
import {getScreeningWindowLicenses} from 'Services/screeningWindowService';
import Loading from '../../../Global/Loading';
import PageStatus from '../../../Teacher/PageStatus';
import ClassWithNoStudents from '../../../Teacher/ErrorMessages/ClassWithNoStudents';
import Error from '../../../Teacher/Error';
import { states } from '../../values/enums';
import Tracking from '../../blocks/Table/Tracking';
import creators from '../../state/tracking/creators';
import moment from "moment";
import {Alert} from "Components/Global/Alert";
import {Tooltip, tooltipTypes} from "Components/Global/Tooltip";

class TrackingContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isScrolled: false,
      hasInitialData: false,
      customerScreeningWindow: {},
    };

    this.onSort = this.onSort.bind(this);
    this.onCell = this.onCell.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);
  }

  componentDidMount () {
   this.props.initializeData();
   this.getCustomerScreeningWindow();
  }

  async getCustomerScreeningWindow() {
    const {districtId, schoolId} = getUserData();
    this.setState({
      customerScreeningWindow: await getScreeningWindowLicenses(districtId, schoolId),
    });
  }

  onSort (type) {
    this.props.trackingSort(type);
  }

  onCell (data) {
    // TODO figure out what Matt intended this code to do
  }

  // conditionally enable scroll css styling
  onTableScroll(event) {
    let scrollTop = event.nativeEvent.srcElement.scrollTop;
    let isScrolled = (scrollTop > 8);

    if(isScrolled !== this.state.isScrolled) {
      this.setState({isScrolled: isScrolled})
    }
  }

  render () {
    const { report, sorts, selectedScreeningWindow, } = this.props;

    const reportContainerStyles = cx({
     'reports-container': true,
     'tracking': true,
     'scrolled': this.state.isScrolled
    });

    let TrackingContents;
    if(this.props.reportStatus && this.props.reportStatus.type === states.COMPLETE) {
      if(report && report.data && report.data.length > 0) {
        TrackingContents =
          <Tracking
            sorts={sorts}
            onSelect={this.onCell}
            onSort={this.onSort}
            onScroll={this.onTableScroll}
            reportData={report.data}
            cutoffs={report.cutoffs}
            isScrolled={this.state.isScrolled}
            isPastWindow={selectedScreeningWindow.isPast}
            history={this.props.history}
            getData={this.props.initializeData}
          />
      } else if(!this.props.students || (Array.isArray(this.props.students) && this.props.students.length == 0)){
        TrackingContents = <ClassWithNoStudents />;
      } else {
        let equated = false;
        if(this.props.selectedMetric && this.props.selectedMetric.value == 'ORF' && this.props.selectedEquating) {
          equated = true;
        }
        TrackingContents =
          <PageStatus
            isAggregateReport= {true}
            viewText= "activity"
            equated={equated}
          />;
      }
    } else if(this.props.reportStatus && this.props.reportStatus.type === states.ERROR) {
      TrackingContents = <Error />;
    } else {
      TrackingContents = <Loading />;
    }

    return (
      <div className={reportContainerStyles}>
        {TrackingContents}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
  selectedEquating: get(state, 'reports.teacher.equatingSelection', true),
  selectedScreeningWindow: get(state, 'reports.teacher.selectedScreeningWindow', null),
  sorts: get(state, 'reports.tracking.sorts', []),
  report: get(state, 'reports.tracking.report', null),
  reportStatus: get(state, 'reports.tracking.report.status', null),
});

const mapDispatchToProps = (dispatch) => ({
  trackingSelect: (selection) => dispatch(creators.trackingSelect(selection)),
  trackingSort: (sort) => dispatch(creators.trackingSort(sort)),
});

TrackingContainer.propTypes = {
  report: PropTypes.object,
  status: PropTypes.string,
  initializeData: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingContainer);
